var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"password-reset"},[_c('PasswordResetFinishPage',{attrs:{"loading":_vm.loading},on:{"update-password":_vm.updatePassword}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }